import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-services-ville',
    templateUrl: './services-ville.component.html',
    styleUrls: ['./services-ville.component.scss']
})
export class ServicesVilleComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville'/*, 'france'*/];

    loading = false;

    /**
     * Chart repartition
     */
    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d} %)'
        },
        calculable: true,
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            data: ['Restauration', 'Santé', 'Poste', 'Services de proximité', 'Sécurité', 'Autres']
        },
    };

    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.service_iris[this.iris]) {
            irisData = this.favorite.ad_city.service_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.service_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.service_gq[this.secteur];
        }

        let root = this.favorite.ad_city.service;
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }
        this.data = {
            series: [
                {
                    name: 'Commerces',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],

                    data: [
                        {
                            value: Math.round(root.tot_service),
                            name: (Math.round(root.tot_service)).toString() + '\nServices à\nla personne'
                        },

                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['55%', '80%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],

                    data: [
                        {value: Math.round(root.restaurant), name: 'Restauration'},
                        {
                            value: Math.round(root.med_generaliste + root.veto),
                            name: 'Santé'
                        },
                        {
                            value: Math.round(root.agence_poste + root.bureau_poste + root.relais_poste),
                            name: 'Poste'
                        },
                        {
                            value: Math.round(root.coiffeur + root.institut_beaute + root.pressing_laverie),
                            name: 'Services de proximité'
                        },
                        {value: Math.round(root.police + root.gendarm), name: 'Sécurité'},
                        {
                            value: Math.round(root.agence_immo + root.agence_interim
                                + root.auto_ecole + root.banque), name: 'Autres'
                        },
                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['85%', '95%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5,
                    },
                    color: [],
                    data: []
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        //Restauration
        if (root.restaurant) {
            this.data.series[2].data.push({value: Math.round(root.restaurant), name: 'Restaurants'});
            this.data.series[2].color.push('#67C2EF');
        }

        //Santé
        if (root.med_generaliste) {
            this.data.series[2].data.push({value: Math.round(root.med_generaliste), name: 'Médecins généralistes'});
            this.data.series[2].color.push('#418A11');
        }
        if (root.veto) {
            this.data.series[2].data.push({value: Math.round(root.veto), name: 'Vetérinaires'});
            this.data.series[2].color.push('#BDED9E');
        }

        //Poste
        if (root.agence_poste) {
            this.data.series[2].data.push({value: Math.round(root.agence_poste), name: 'Agences postale'});
            this.data.series[2].color.push('#B27805');
        }
        if (root.bureau_poste) {
            this.data.series[2].data.push({value: Math.round(root.bureau_poste), name: 'Bureaux de poste'});
            this.data.series[2].color.push('#E9A00E');
        }
        if (root.relais_poste) {
            this.data.series[2].data.push({value: Math.round(root.relais_poste), name: 'Relais de poste'});
            this.data.series[2].color.push('#FFCA61');
        }

        //Services de proximité
        if (root.coiffeur) {
            this.data.series[2].data.push({value: Math.round(root.coiffeur), name: 'Coiffeur'});
            this.data.series[2].color.push('#04496B');
        }
        if (root.pressing_laverie) {
            this.data.series[2].data.push({value: Math.round(root.pressing_laverie), name: 'Pressing - Laveries'});
            this.data.series[2].color.push('#3389B3');
        }
        if (root.institut_beaute) {
            this.data.series[2].data.push({value: Math.round(root.institut_beaute), name: 'Institut de beauté'});
            this.data.series[2].color.push('#57A1C5');
        }
        // Sécurité
        if (root.police) {
            this.data.series[2].data.push({value: Math.round(root.police), name: 'Police'});
            this.data.series[2].color.push('#C3C3C3');
        }
        if (root.gendarm) {
            this.data.series[2].data.push({value: Math.round(root.gendarm), name: 'Gendarmerie'});
            this.data.series[2].color.push('#C7C7C7');
        }

        //Autres
        if (root.agence_immo) {
            this.data.series[2].data.push({value: Math.round(root.agence_immo), name: 'Agences immobilière'});
            this.data.series[2].color.push('#BE1111');
        }
        if (root.agence_interim) {
            this.data.series[2].data.push({value: Math.round(root.agence_interim), name: 'Agences d\'intérim'});
            this.data.series[2].color.push('#EB2D2D');
        }
        if (root.auto_ecole) {
            this.data.series[2].data.push({value: Math.round(root.auto_ecole), name: 'Auto-écoles'});
            this.data.series[2].color.push('#FF5455');
        }
        if (root.banque) {
            this.data.series[2].data.push({value: Math.round(root.banque), name: 'Banques'});
            this.data.series[2].color.push('#FF7777');
        }

        this.compare = [
            {
                'lib': 'Services à la personne',
                'quartier': (irisData != null ? irisData.tot_service : '-'),
                'secteur': (secteurData != null ? secteurData.tot_service : '-'),
                'ville': this.favorite.ad_city.service.tot_service,
                // 'france': this.favorite.ad_city.service_fr.tot_service,
            },
            {
                'lib': 'Restauration',
                'quartier': (irisData != null ? irisData.restaurant : '-'),
                'secteur': (secteurData != null ? secteurData.restaurant : '-'),
                'ville': this.favorite.ad_city.service.restaurant,
                // 'france': this.favorite.ad_city.service_fr.restaurant,
            },
            {
                'lib': 'Santé',
                'quartier': (irisData != null ? irisData.med_generaliste + irisData.veto : '-'),
                'secteur': (secteurData != null ? secteurData.med_generaliste + secteurData.veto : '-'),
                'ville': this.favorite.ad_city.service.med_generaliste + this.favorite.ad_city.service.veto,
                // 'france': this.favorite.ad_city.service_fr.med_generaliste + this.favorite.ad_city.service_fr.veto,
            },
            // {
            //     'lib': ' • Médecins généralistes',
            //     'quartier' : (irisData != null ? irisData.med_generaliste : '-'),
            //     'secteur': (secteurData != null ? secteurData.med_generaliste : '-'),
            //     'ville': this.favorite.ad_city.service.med_generaliste,
            // },
            // {
            //     'lib': ' • Vetérinaires',
            //     'quartier' : (irisData != null ? irisData.veto : '-'),
            //     'secteur': (secteurData != null ? secteurData.veto : '-'),
            //     'ville': this.favorite.ad_city.service.veto,
            // },
            {
                'lib': 'Poste',
                'quartier': (irisData != null ? irisData.agence_poste + irisData.bureau_poste + irisData.relais_poste : '-'),
                'secteur': (secteurData != null ? secteurData.agence_poste + secteurData.bureau_poste + secteurData.relais_poste : '-'),
                'ville': this.favorite.ad_city.service.agence_poste + this.favorite.ad_city.service.bureau_poste + this.favorite.ad_city.service.relais_poste,
                // 'france': this.favorite.ad_city.service_fr.agence_poste + this.favorite.ad_city.service_fr.bureau_poste + this.favorite.ad_city.service_fr.relais_poste,
            },
            // {
            //     'lib': ' • Agences postale',
            //     'quartier' : (irisData != null ? irisData.agence_poste : '-'),
            //     'secteur': (secteurData != null ? secteurData.agence_poste : '-'),
            //     'ville': this.favorite.ad_city.service.agence_poste,
            // },
            // {
            //     'lib': ' • Bureaux de poste',
            //     'quartier' : (irisData != null ? irisData.bureau_poste : '-'),
            //     'secteur': (secteurData != null ? secteurData.bureau_poste : '-'),
            //     'ville': this.favorite.ad_city.service.bureau_poste,
            // },
            // {
            //     'lib': ' • Relais de poste',
            //     'quartier' : (irisData != null ? irisData.relais_poste : '-'),
            //     'secteur': (secteurData != null ? secteurData.relais_poste : '-'),
            //     'ville': this.favorite.ad_city.service.relais_poste,
            // },
            {
                'lib': 'Services de proximité',
                'quartier': (irisData != null ? irisData.coiffeur + irisData.institut_beaute + irisData.pressing_laverie : '-'),
                'secteur': (secteurData != null ? secteurData.coiffeur + secteurData.institut_beaute + secteurData.pressing_laverie : '-'),
                'ville': this.favorite.ad_city.service.coiffeur + this.favorite.ad_city.service.institut_beaute + this.favorite.ad_city.service.pressing_laverie,
                // 'france': this.favorite.ad_city.service_fr.coiffeur + this.favorite.ad_city.service_fr.institut_beaute + this.favorite.ad_city.service_fr.pressing_laverie,
            },
            // {
            //     'lib': ' • Coiffeur',
            //     'quartier' : (irisData != null ? irisData.coiffeur : '-'),
            //     'secteur': (secteurData != null ? secteurData.coiffeur : '-'),
            //     'ville': this.favorite.ad_city.service.coiffeur,
            // },
            // {
            //     'lib': ' • Pressing - Laveries',
            //     'quartier' : (irisData != null ? irisData.institut_beaute : '-'),
            //     'secteur': (secteurData != null ? secteurData.institut_beaute : '-'),
            //     'ville': this.favorite.ad_city.service.institut_beaute,
            // },
            // {
            //     'lib': ' • Institut de beauté',
            //     'quartier' : (irisData != null ? irisData.pressing_laverie : '-'),
            //     'secteur': (secteurData != null ? secteurData.pressing_laverie : '-'),
            //     'ville': this.favorite.ad_city.service.pressing_laverie,
            // },
            {
                'lib': 'Sécurité',
                'quartier': (irisData != null ? irisData.police + irisData.gendarm : '-'),
                'secteur': (secteurData != null ? secteurData.police + secteurData.gendarm : '-'),
                'ville': this.favorite.ad_city.service.police + this.favorite.ad_city.service.gendarm,
                // 'france': this.favorite.ad_city.service_fr.police + this.favorite.ad_city.service_fr.gendarm,
            },
            // {
            //     'lib': ' • Police',
            //     'quartier' : (irisData != null ? irisData.police : '-'),
            //     'secteur': (secteurData != null ? secteurData.police : '-'),
            //     'ville': this.favorite.ad_city.service.police,
            // },
            // {
            //     'lib': ' • Gendarmerie',
            //     'quartier' : (irisData != null ? irisData.gendarm : '-'),
            //     'secteur': (secteurData != null ? secteurData.gendarm : '-'),
            //     'ville': this.favorite.ad_city.service.gendarm,
            // },
            {
                'lib': 'Autres',
                'quartier': (irisData != null ? irisData.agence_immo + irisData.agence_interim + irisData.auto_ecole + irisData.banque : '-'),
                'secteur': (secteurData != null ? secteurData.agence_immo + secteurData.agence_interim + secteurData.auto_ecole + secteurData.banque : '-'),
                'ville': this.favorite.ad_city.service.agence_immo + this.favorite.ad_city.service.agence_interim + this.favorite.ad_city.service.auto_ecole + this.favorite.ad_city.service.banque,
                // 'france': this.favorite.ad_city.service_fr.agence_immo + this.favorite.ad_city.service_fr.agence_interim + this.favorite.ad_city.service_fr.auto_ecole + this.favorite.ad_city.service_fr.banque,
            },
            // {
            //     'lib': ' • Agences immobilière',
            //     'quartier' : (irisData != null ? irisData.agence_immo : '-'),
            //     'secteur': (secteurData != null ? secteurData.agence_immo : '-'),
            //     'ville': this.favorite.ad_city.service.agence_immo,
            // },
            // {
            //     'lib': ' • Agences d\'intérim',
            //     'quartier' : (irisData != null ? irisData.agence_interim : '-'),
            //     'secteur': (secteurData != null ? secteurData.agence_interim : '-'),
            //     'ville': this.favorite.ad_city.service.agence_interim,
            // },
            // {
            //     'lib': ' • Auto-écoles',
            //     'quartier' : (irisData != null ? irisData.auto_ecole : '-'),
            //     'secteur': (secteurData != null ? secteurData.auto_ecole : '-'),
            //     'ville': this.favorite.ad_city.service.auto_ecole,
            // },
            // {
            //     'lib': ' • Banques',
            //     'quartier' : (irisData != null ? irisData.banque : '-'),
            //     'secteur': (secteurData != null ? secteurData.banque : '-'),
            //     'ville': this.favorite.ad_city.service.banque,
            // },
        ];
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
